<template>
  <!-- footer -->
  <div class="sso-home-footer">
    <div class="sso-footer-list-wrapper">
    <div class="sso-footer-list sso-inner">
      <div class="sso-footer-list-left">
        <span>主办单位：湖北省知识产权局</span>
        <span style="margin-left: 57px;margin-right: 64px;">|</span>
        <span>制作维护：湖北省知识产权局</span>
        <span style="margin-left: 57px;margin-right: 64px;">|</span>
        <span>电话：027-86759088</span>
        <span style="margin-left: 57px;margin-right: 64px;">|</span>
        <span>地址：武汉市武昌区公正路19号</span>
        <span style="margin-left: 57px;margin-right: 64px;">|</span>
        <span>网站标识码：4200000072</span>
      </div>
      <div class="sso-footer-list-right">
        <span>站内导航：</span>
        <span style="cursor: pointer;" @click="handleUrl('http://zscqj.hubei.gov.cn/fzlm/wzdt/')">网站地图</span>
        <span @click="handleUrl('https://c3.icoremail.net/')" style="margin-left: 30px;cursor: pointer;">内部邮箱</span>
        <span @click="handleUrl('http://zscqj.hubei.gov.cn/fzlm/xxtj/index.shtml')" style="margin-left: 30px;cursor: pointer;">信息统计</span>
      </div>
    </div>
    </div>
    <div class="sso-footer-bottm">
      鄂ICP备20000291号 鄂公网安备42010602004146号
    </div>
  </div>
</template>

<script>
export default {
  name: "ssoFooter",
  data() {
    return {};
  },
  methods: {
    handleUrl(url) {
      window.open(url,'_blank')
    }
  },
};
</script>

<style lang="scss" scoped>
.sso-home-footer {
  width: 100%;
  height: 68px;
  .sso-footer-list-wrapper {
    height: 40px;
    background: #003A6C;
    .sso-footer-list {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: inherit;
      &-left {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 13px;
        color: #FFFFFF;
      }
      &-right {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 13px;
        color: #FFFFFF;
      }
    }
  }
  .sso-footer-bottm{
    height: 28px;
    line-height: 28px;
    background: #002D54;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    text-align: center;
  }
}
</style>
